import { cookieDialogStore } from './CookieDialogStore';

export function useCookieDialog() {
    const {
        submitDialog,
        dialogSubmitted,
        tempTelemetry,
        tempDiagnostics,
        tempYoutube
    } = cookieDialogStore.useState(['submitDialog', 'dialogSubmitted', 'tempTelemetry', 'tempDiagnostics', 'tempYoutube']);

    function onDiagnostics(_event: unknown, checked: boolean) {
        cookieDialogStore.updateState({ tempDiagnostics: checked });
    }

    function onYoutube(_event: unknown, checked: boolean) {
        cookieDialogStore.updateState({ tempYoutube: checked });
    }

    function onTelemetry(_event: unknown, checked: boolean) {
        cookieDialogStore.updateState({ tempTelemetry: checked });
    }

    function selectAll() {
        cookieDialogStore.updateState({
            dialogSubmitted: true,
            diagnostics: true,
            telemetry: true,
            youtube: true,
        });

        return submitDialog?.();
    }

    function apply() {
        cookieDialogStore.updateState({
            dialogSubmitted: true,
            diagnostics: tempDiagnostics,
            telemetry: tempTelemetry,
            youtube: tempYoutube,
        });
        submitDialog?.();
    }

    return {
        onDiagnostics,
        onYoutube,
        onTelemetry,
        selectAll,
        apply,
        dialogSubmitted,
        temporaryValues: {
            diagnostics: tempDiagnostics,
            telemetry: tempTelemetry,
            youtube: tempYoutube,
        }
    };
}